module.exports = __webpack_public_path__ + "img/发布发货计划icon@2x.dc6cff04.png";